import { PaytrieAPI } from '@paytrie/client'

export const userCancelTransaction = async (
  transactionId: string
): Promise<{ status: number }> => {
  const res = await PaytrieAPI.cancelTransaction(transactionId)
  return { status: res.status }
}
